module.exports = __webpack_public_path__ + "img/fiveinarow_white.ed32890e.svg";